import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
import CreditCards from '../views/MenuFiles/CreditCards.vue'
import Divisions from '../views/MenuFiles/Divisions.vue'
import Employees from '../views/MenuFiles/Employees.vue'
import Users from '../views/MenuFiles/Users.vue'
import SubDivisions from '../views/MenuFiles/SubDivisions.vue'
import Routes from '../views/MenuFiles/Routes.vue'
import MenuDesktop from '../views/MenuDesktop.vue'
import PrintLandfills from '../views/MenuReports/PrintLandfills.vue'
import PrintDivisions from '../views/MenuReports/PrintDivisions.vue'
import PrintSubdivisions from '../views/MenuReports/PrintSubdivisions.vue'
import PrintEmployees from '../views/MenuReports/PrintEmployees.vue'
import PrintRoutes from '../views/MenuReports/PrintRoutes.vue'
import Landfills from '../views/MenuTransactions/Landfills.vue'
 

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home
  },
  {
    path: '/creditcards',
    name: 'CreditCards',
    component: CreditCards
  },
  {
    path: '/divisiones',
    name: 'Divisions',
    component: Divisions
  },
  {
    path: '/subdivisiones',
    name: 'SubDivisions',
    component: SubDivisions
  },
  {
    path: '/routes',
    name: 'Routes',
    component: Routes
  },
  {
    path: '/employees',
    name: 'Employees',
    component: Employees
  },
  {
    path: '/users',
    name: 'Users',
    component: Users
  },
  {
    path: '/menudesktop',
    name: 'MenuDesktop',
    component: MenuDesktop
  },
  {
    path: '/printlandfills',
    name: 'PrintLandfills',
    component: PrintLandfills
  },
  {
    path: '/printdivisions',
    name: 'PrintDivisions',
    component: PrintDivisions
  },
  {
    path: '/printsubdivisions',
    name: 'PrintSubdivisions',
    component: PrintSubdivisions
  },
  {
    path: '/printroutes',
    name: 'PrintRoutes',
    component: PrintRoutes
  },
  {
    path: '/printemployees',
    name: 'PrintEmployees',
    component: PrintEmployees
  },
  {
    path: '/landfills',
    name: 'Landfills',
    component: Landfills
  }
  
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
